/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import axios from 'axios'
import appConfig from '../../config/appConfig'
import { Aborted, getApiServer } from '../../api/common'

const apiServer = getApiServer('../settings')

const optionsAPI = {
  fetchOptions: async (ops) => {
    const { signal } = ops
    try {
      const response = await apiServer.get(`/options`, {
        signal,
      })
      return response.data
    } catch (err) {
      if (axios.isCancel(err)) {
        throw new Aborted('Call aborted', err)
      } else {
        console.error(err)
        throw Error('Unable to get DB Options')
      }
    }
  },
}

export default optionsAPI
